<ion-item>
  <ion-select class="form-control" [(ngModel)]="selectedLanguage" name="selectedLanguage"
              [selectedText]="displayNameByLanguage[selectedLanguage]"
              [label]="('language-switcher-component.select-language' | translate)"
              (ionChange)="selectedLanguageChanged()">
    <ion-select-option *ngFor="let lang of availableLanguages"
                       value="{{lang}}">{{ displayNameByLanguage[lang] }}</ion-select-option>
  </ion-select>
</ion-item>
